/** In-app notification polling policy (MYN-55) - no push channel, short-interval poll instead. */
export const NOTIFICATIONS_POLL_MS = 30_000;

/**
 * The startup bell's data-room copy (v1.2). FR-145: Premium switched on, with
 * the period's end date. FR-137 (MYN-259): the reminders, in the client's
 * words; `{days}` is a count with its unit, e.g. "30 days".
 */
export const DATA_ROOM_NOTIFICATION_COPY = {
  PREMIUM_GRANTED: 'Your AI Data Room access is on until {date}',
  PREMIUM_GRANTED_UNDATED: 'Your AI Data Room access is on',
  PREMIUM_EXPIRING: 'Your Premium access expires in {days}. To continue, contact support.',
  PREMIUM_EXPIRING_UNDATED: 'Your Premium access expires soon. To continue, contact support.',
  PREMIUM_EXPIRED: 'Your Premium access has expired. To continue, contact support.',
} as const;
